import React, { useState, useEffect } from 'react';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';
import { advancedBillingService } from '../../../services/advancedBillingService';
import { getTranslation } from '../../../utils/translations';

// Comprehensive country list with ISO codes
const COUNTRIES_LIST = [
  { name: 'Afghanistan', code: 'AF', currency: 'AFN' },
  { name: 'Albania', code: 'AL', currency: 'ALL' },
  { name: 'Algeria', code: 'DZ', currency: 'DZD' },
  { name: 'Andorra', code: 'AD', currency: 'EUR' },
  { name: 'Angola', code: 'AO', currency: 'AOA' },
  { name: 'Argentina', code: 'AR', currency: 'ARS' },
  { name: 'Armenia', code: 'AM', currency: 'AMD' },
  { name: 'Australia', code: 'AU', currency: 'AUD' },
  { name: 'Austria', code: 'AT', currency: 'EUR' },
  { name: 'Azerbaijan', code: 'AZ', currency: 'AZN' },
  { name: 'Bahrain', code: 'BH', currency: 'BHD' },
  { name: 'Bangladesh', code: 'BD', currency: 'BDT' },
  { name: 'Belarus', code: 'BY', currency: 'BYN' },
  { name: 'Belgium', code: 'BE', currency: 'EUR' },
  { name: 'Benin', code: 'BJ', currency: 'XOF' },
  { name: 'Bolivia', code: 'BO', currency: 'BOB' },
  { name: 'Bosnia and Herzegovina', code: 'BA', currency: 'BAM' },
  { name: 'Botswana', code: 'BW', currency: 'BWP' },
  { name: 'Brazil', code: 'BR', currency: 'BRL' },
  { name: 'Bulgaria', code: 'BG', currency: 'BGN' },
  { name: 'Burkina Faso', code: 'BF', currency: 'XOF' },
  { name: 'Burundi', code: 'BI', currency: 'BIF' },
  { name: 'Cambodia', code: 'KH', currency: 'KHR' },
  { name: 'Cameroon', code: 'CM', currency: 'XAF' },
  { name: 'Canada', code: 'CA', currency: 'CAD' },
  { name: 'Chad', code: 'TD', currency: 'XAF' },
  { name: 'Chile', code: 'CL', currency: 'CLP' },
  { name: 'China', code: 'CN', currency: 'CNY' },
  { name: 'Colombia', code: 'CO', currency: 'COP' },
  { name: 'Costa Rica', code: 'CR', currency: 'CRC' },
  { name: 'Croatia', code: 'HR', currency: 'EUR' },
  { name: 'Cuba', code: 'CU', currency: 'CUP' },
  { name: 'Cyprus', code: 'CY', currency: 'EUR' },
  { name: 'Czech Republic', code: 'CZ', currency: 'CZK' },
  { name: 'Denmark', code: 'DK', currency: 'DKK' },
  { name: 'Dominican Republic', code: 'DO', currency: 'DOP' },
  { name: 'Ecuador', code: 'EC', currency: 'USD' },
  { name: 'Egypt', code: 'EG', currency: 'EGP' },
  { name: 'Estonia', code: 'EE', currency: 'EUR' },
  { name: 'Ethiopia', code: 'ET', currency: 'ETB' },
  { name: 'Finland', code: 'FI', currency: 'EUR' },
  { name: 'France', code: 'FR', currency: 'EUR' },
  { name: 'Georgia', code: 'GE', currency: 'GEL' },
  { name: 'Germany', code: 'DE', currency: 'EUR' },
  { name: 'Ghana', code: 'GH', currency: 'GHS' },
  { name: 'Greece', code: 'GR', currency: 'EUR' },
  { name: 'Guatemala', code: 'GT', currency: 'GTQ' },
  { name: 'Guinea', code: 'GN', currency: 'GNF' },
  { name: 'Haiti', code: 'HT', currency: 'HTG' },
  { name: 'Honduras', code: 'HN', currency: 'HNL' },
  { name: 'Hungary', code: 'HU', currency: 'HUF' },
  { name: 'Iceland', code: 'IS', currency: 'ISK' },
  { name: 'India', code: 'IN', currency: 'INR' },
  { name: 'Indonesia', code: 'ID', currency: 'IDR' },
  { name: 'Iran', code: 'IR', currency: 'IRR' },
  { name: 'Iraq', code: 'IQ', currency: 'IQD' },
  { name: 'Ireland', code: 'IE', currency: 'EUR' },
  { name: 'Israel', code: 'IL', currency: 'ILS' },
  { name: 'Italy', code: 'IT', currency: 'EUR' },
  { name: 'Ivory Coast', code: 'CI', currency: 'XOF' },
  { name: 'Jamaica', code: 'JM', currency: 'JMD' },
  { name: 'Japan', code: 'JP', currency: 'JPY' },
  { name: 'Jordan', code: 'JO', currency: 'JOD' },
  { name: 'Kazakhstan', code: 'KZ', currency: 'KZT' },
  { name: 'Kenya', code: 'KE', currency: 'KES' },
  { name: 'Kuwait', code: 'KW', currency: 'KWD' },
  { name: 'Latvia', code: 'LV', currency: 'EUR' },
  { name: 'Lebanon', code: 'LB', currency: 'LBP' },
  { name: 'Libya', code: 'LY', currency: 'LYD' },
  { name: 'Lithuania', code: 'LT', currency: 'EUR' },
  { name: 'Luxembourg', code: 'LU', currency: 'EUR' },
  { name: 'Madagascar', code: 'MG', currency: 'MGA' },
  { name: 'Malawi', code: 'MW', currency: 'MWK' },
  { name: 'Malaysia', code: 'MY', currency: 'MYR' },
  { name: 'Mali', code: 'ML', currency: 'XOF' },
  { name: 'Malta', code: 'MT', currency: 'EUR' },
  { name: 'Mauritania', code: 'MR', currency: 'MRU' },
  { name: 'Mauritius', code: 'MU', currency: 'MUR' },
  { name: 'Mexico', code: 'MX', currency: 'MXN' },
  { name: 'Moldova', code: 'MD', currency: 'MDL' },
  { name: 'Monaco', code: 'MC', currency: 'EUR' },
  { name: 'Mongolia', code: 'MN', currency: 'MNT' },
  { name: 'Montenegro', code: 'ME', currency: 'EUR' },
  { name: 'Morocco', code: 'MA', currency: 'MAD' },
  { name: 'Mozambique', code: 'MZ', currency: 'MZN' },
  { name: 'Myanmar', code: 'MM', currency: 'MMK' },
  { name: 'Namibia', code: 'NA', currency: 'NAD' },
  { name: 'Nepal', code: 'NP', currency: 'NPR' },
  { name: 'Netherlands', code: 'NL', currency: 'EUR' },
  { name: 'New Zealand', code: 'NZ', currency: 'NZD' },
  { name: 'Nicaragua', code: 'NI', currency: 'NIO' },
  { name: 'Niger', code: 'NE', currency: 'XOF' },
  { name: 'Nigeria', code: 'NG', currency: 'NGN' },
  { name: 'North Macedonia', code: 'MK', currency: 'MKD' },
  { name: 'Norway', code: 'NO', currency: 'NOK' },
  { name: 'Oman', code: 'OM', currency: 'OMR' },
  { name: 'Pakistan', code: 'PK', currency: 'PKR' },
  { name: 'Palestine', code: 'PS', currency: 'ILS' },
  { name: 'Panama', code: 'PA', currency: 'PAB' },
  { name: 'Paraguay', code: 'PY', currency: 'PYG' },
  { name: 'Peru', code: 'PE', currency: 'PEN' },
  { name: 'Philippines', code: 'PH', currency: 'PHP' },
  { name: 'Poland', code: 'PL', currency: 'PLN' },
  { name: 'Portugal', code: 'PT', currency: 'EUR' },
  { name: 'Qatar', code: 'QA', currency: 'QAR' },
  { name: 'Romania', code: 'RO', currency: 'RON' },
  { name: 'Russia', code: 'RU', currency: 'RUB' },
  { name: 'Rwanda', code: 'RW', currency: 'RWF' },
  { name: 'Saudi Arabia', code: 'SA', currency: 'SAR' },
  { name: 'Senegal', code: 'SN', currency: 'XOF' },
  { name: 'Serbia', code: 'RS', currency: 'RSD' },
  { name: 'Singapore', code: 'SG', currency: 'SGD' },
  { name: 'Slovakia', code: 'SK', currency: 'EUR' },
  { name: 'Slovenia', code: 'SI', currency: 'EUR' },
  { name: 'Somalia', code: 'SO', currency: 'SOS' },
  { name: 'South Africa', code: 'ZA', currency: 'ZAR' },
  { name: 'South Korea', code: 'KR', currency: 'KRW' },
  { name: 'South Sudan', code: 'SS', currency: 'SSP' },
  { name: 'Spain', code: 'ES', currency: 'EUR' },
  { name: 'Sri Lanka', code: 'LK', currency: 'LKR' },
  { name: 'Sudan', code: 'SD', currency: 'SDG' },
  { name: 'Sweden', code: 'SE', currency: 'SEK' },
  { name: 'Switzerland', code: 'CH', currency: 'CHF' },
  { name: 'Syria', code: 'SY', currency: 'SYP' },
  { name: 'Taiwan', code: 'TW', currency: 'TWD' },
  { name: 'Tanzania', code: 'TZ', currency: 'TZS' },
  { name: 'Thailand', code: 'TH', currency: 'THB' },
  { name: 'Togo', code: 'TG', currency: 'XOF' },
  { name: 'Tunisia', code: 'TN', currency: 'TND' },
  { name: 'Turkey', code: 'TR', currency: 'TRY' },
  { name: 'Uganda', code: 'UG', currency: 'UGX' },
  { name: 'Ukraine', code: 'UA', currency: 'UAH' },
  { name: 'United Arab Emirates', code: 'AE', currency: 'AED' },
  { name: 'United Kingdom', code: 'GB', currency: 'GBP' },
  { name: 'United States', code: 'US', currency: 'USD' },
  { name: 'Uruguay', code: 'UY', currency: 'UYU' },
  { name: 'Uzbekistan', code: 'UZ', currency: 'UZS' },
  { name: 'Venezuela', code: 'VE', currency: 'VES' },
  { name: 'Vietnam', code: 'VN', currency: 'VND' },
  { name: 'Yemen', code: 'YE', currency: 'YER' },
  { name: 'Zambia', code: 'ZM', currency: 'ZMW' },
  { name: 'Zimbabwe', code: 'ZW', currency: 'ZWL' }
];

const AddCountryModal = ({ isOpen, onClose, onSuccess, language }) => {
  const t = getTranslation(language);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [regions, setRegions] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [formData, setFormData] = useState({
    countryCode: '',
    countryName: '',
    regionId: '',
    currencyCode: '',
    taxRate: 0,
    paymentMethods: [],
    supportedLanguages: [],
    isActive: true
  });

  const commonPaymentMethods = [
    'Bank Transfer',
    'Credit Card',
    'Debit Card',
    'PayPal',
    'Cash',
    'Check',
    'Mobile Payment'
  ];

  // Convert COUNTRIES_LIST to options format for Select component
  const countryOptions = COUNTRIES_LIST?.map(country => ({
    value: country?.name,
    label: `${country?.name} (${country?.code})`,
    code: country?.code,
    currency: country?.currency
  }));

  const regionOptions = regions?.map(region => ({
    value: region?.id,
    label: region?.regionName
  })) || [];

  useEffect(() => {
    if (isOpen) {
      fetchRegions();
      fetchLanguages();
    }
  }, [isOpen]);

  const fetchRegions = async () => {
    try {
      const data = await advancedBillingService?.getAllRegions();
      setRegions(data?.filter(r => r?.isActive) || []);
    } catch (err) {
      console.error('Error fetching regions:', err);
    }
  };

  const fetchLanguages = async () => {
    try {
      const data = await advancedBillingService?.getAllLanguages();
      setLanguages(data?.filter(l => l?.isActive) || []);
    } catch (err) {
      console.error('Error fetching languages:', err);
    }
  };

  const handleCountrySelect = (selectedValue) => {
    const country = COUNTRIES_LIST?.find(c => c?.name === selectedValue);
    
    if (country) {
      setSelectedCountry(country);
      setFormData(prev => ({
        ...prev,
        countryName: country?.name,
        countryCode: country?.code,
        currencyCode: country?.currency
      }));
    } else {
      setSelectedCountry(null);
      setFormData(prev => ({
        ...prev,
        countryName: '',
        countryCode: '',
        currencyCode: ''
      }));
    }
    setError(null);
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    setError(null);
  };

  const handlePaymentMethodToggle = (method) => {
    setFormData(prev => ({
      ...prev,
      paymentMethods: prev?.paymentMethods?.includes(method)
        ? prev?.paymentMethods?.filter(m => m !== method)
        : [...prev?.paymentMethods, method]
    }));
  };

  const handleLanguageToggle = (langCode) => {
    setFormData(prev => ({
      ...prev,
      supportedLanguages: prev?.supportedLanguages?.includes(langCode)
        ? prev?.supportedLanguages?.filter(code => code !== langCode)
        : [...prev?.supportedLanguages, langCode]
    }));
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    
    if (!formData?.countryCode || !formData?.countryName || !formData?.regionId || !formData?.currencyCode) {
      setError(language === 'FR' ? 'Veuillez remplir tous les champs obligatoires' : 
               language === 'EN'? 'Please fill in all required fields' : 'Proszę wypełnić wszystkie wymagane pola');
      return;
    }

    if (formData?.supportedLanguages?.length === 0) {
      setError(language === 'FR' ? 'Veuillez sélectionner au moins une langue' : 
               language === 'EN'? 'Please select at least one language' : 'Proszę wybrać co najmniej jeden język');
      return;
    }

    try {
      setLoading(true);
      setError(null);
      await advancedBillingService?.createCountry(formData);
      onSuccess?.();
      onClose?.();
      setFormData({
        countryCode: '',
        countryName: '',
        regionId: '',
        currencyCode: '',
        taxRate: 0,
        paymentMethods: [],
        supportedLanguages: [],
        isActive: true
      });
      setSelectedCountry(null);
    } catch (err) {
      console.error('Error creating country:', err);
      setError(err?.message || (language === 'FR' ? 'Erreur lors de la création du pays' : 
                                 language === 'EN'? 'Error creating country' : 'Błąd podczas tworzenia kraju'));
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-card rounded-lg shadow-xl max-w-3xl w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-card border-b border-border p-6 flex items-center justify-between">
          <h2 className="text-2xl font-bold text-foreground">
            {t?.international?.addCountry || 'Add Country'}
          </h2>
          <button
            onClick={onClose}
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            <Icon name="X" size={24} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          {error && (
            <div className="bg-destructive/10 border border-destructive text-destructive px-4 py-3 rounded-lg flex items-center gap-2">
              <Icon name="AlertCircle" size={20} />
              <span>{error}</span>
            </div>
          )}

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              {language === 'FR' ? 'Sélectionner un Pays' : language === 'EN' ? 'Select Country' : 'Wybierz Kraj'} *
            </label>
            <Select
              value={formData?.countryName}
              onChange={handleCountrySelect}
              options={countryOptions}
              placeholder={language === 'FR' ? 'Choisir un pays...' : language === 'EN' ? 'Choose a country...' : 'Wybierz kraj...'}
              searchable
              required
            />
          </div>

          {selectedCountry && (
            <>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-foreground mb-2">
                    {t?.international?.countryCode || 'Country Code'}
                  </label>
                  <Input
                    type="text"
                    value={formData?.countryCode}
                    disabled
                    className="bg-muted"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-foreground mb-2">
                    {t?.international?.currency || 'Currency'}
                  </label>
                  <Input
                    type="text"
                    value={formData?.currencyCode}
                    disabled
                    className="bg-muted"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-foreground mb-2">
                    {t?.international?.region || 'Region'} *
                  </label>
                  <Select
                    value={formData?.regionId}
                    onChange={(value) => handleInputChange('regionId', value)}
                    options={regionOptions}
                    placeholder={language === 'FR' ? 'Choisir une région...' : language === 'EN' ? 'Choose a region...' : 'Wybierz region...'}
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-foreground mb-2">
                    {t?.international?.taxRate || 'Tax Rate'} (%)
                  </label>
                  <Input
                    type="number"
                    value={formData?.taxRate}
                    onChange={(e) => handleInputChange('taxRate', parseFloat(e?.target?.value) || 0)}
                    placeholder="19"
                    min="0"
                    max="100"
                    step="0.01"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-foreground mb-3">
                  {language === 'FR' ? 'Langues Supportées' : language === 'EN' ? 'Supported Languages' : 'Obsługiwane Języki'} *
                </label>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                  {languages?.map((lang) => (
                    <label
                      key={lang?.id}
                      className="flex items-center gap-2 p-3 border border-border rounded-lg cursor-pointer hover:bg-muted transition-colors"
                    >
                      <input
                        type="checkbox"
                        checked={formData?.supportedLanguages?.includes(lang?.languageCode)}
                        onChange={() => handleLanguageToggle(lang?.languageCode)}
                        className="rounded border-border text-primary focus:ring-primary"
                      />
                      <span className="text-sm text-foreground">{lang?.languageName}</span>
                    </label>
                  ))}
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-foreground mb-3">
                  {t?.international?.paymentMethods || 'Payment Methods'}
                </label>
                <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                  {commonPaymentMethods?.map((method) => (
                    <label
                      key={method}
                      className="flex items-center gap-2 p-3 border border-border rounded-lg cursor-pointer hover:bg-muted transition-colors"
                    >
                      <input
                        type="checkbox"
                        checked={formData?.paymentMethods?.includes(method)}
                        onChange={() => handlePaymentMethodToggle(method)}
                        className="rounded border-border text-primary focus:ring-primary"
                      />
                      <span className="text-sm text-foreground">{method}</span>
                    </label>
                  ))}
                </div>
              </div>

              <div className="flex items-center gap-2">
                <input
                  type="checkbox"
                  id="isActive"
                  checked={formData?.isActive}
                  onChange={(e) => handleInputChange('isActive', e?.target?.checked)}
                  className="rounded border-border text-primary focus:ring-primary"
                />
                <label htmlFor="isActive" className="text-sm font-medium text-foreground cursor-pointer">
                  {t?.common?.active || 'Active'}
                </label>
              </div>
            </>
          )}

          <div className="flex items-center justify-end gap-3 pt-4 border-t border-border">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              disabled={loading}
            >
              {t?.common?.cancel || 'Cancel'}
            </Button>
            <Button
              type="submit"
              variant="primary"
              disabled={loading || !selectedCountry}
            >
              {loading ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                  {language === 'FR' ? 'Création...' : language === 'EN' ? 'Creating...' : 'Tworzenie...'}
                </>
              ) : (
                <>
                  <Icon name="Plus" size={16} className="mr-2" />
                  {t?.common?.create || 'Create'}
                </>
              )}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddCountryModal;